module.exports = __webpack_public_path__ + "static/img/img02.7a7e0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/sp/img02.jpg
// module id = cR6S
// module chunks = 0